import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Brooklyn Park",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/states/minnesota",
  heroImageQuery:
    "Aerial view of Brooklyn Park Minnesota suburban cityscape with the Mississippi River, residential neighborhoods, green parks and trails, modern community buildings, warm golden hour lighting, clean professional photography, no readable text or signs",
  heroImageSeq: "brooklyn-park-mn-hero",
  heroDescription:
    "Business trip to Europe in two weeks? Family vacation to Mexico and your child's passport expired? Need a first-time passport for a new job requiring international travel? We help Brooklyn Park residents — from northwest metro families to North Hennepin Community College students — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30–100% lower than FedEx, Staples, and other third-party passport courier resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  geoPosition: "45.0941; -93.3563",
  geoPlacename: "Brooklyn Park, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/brooklyn-park/",
  localAreaTitle: "Serving Brooklyn Park & Northwest Hennepin County",
  localAreaText: [
    "Brooklyn Park, Minnesota is the sixth-largest city in the state and one of the most diverse communities in the northwest metro. Located along the Mississippi River with direct access to major highways, this community serves as a residential hub for commuters to Minneapolis, Maple Grove, and the broader Twin Cities region. The city's population includes a significant number of immigrant families, many of whom need passport services for international travel to visit relatives abroad, for citizenship ceremonies, or for family reunification.",
    "North Hennepin Community College brings a steady stream of students planning study-abroad programs, international internships, and academic exchanges. Many of these students discover their passport needs only after acceptance into a program — often with deadlines that standard government processing cannot meet. The college's diverse student body also includes many first-generation U.S. citizens who need guidance on first-time passport applications and the acceptance clerk process.",
    "Beyond education, Brooklyn Park is a family-oriented community with active travel patterns. Residents book Caribbean cruises, European heritage trips, and visits to family in Asia, Africa, and Latin America. The proximity to MSP Airport means that when a passport issue is discovered, travelers have very little time to resolve it before their departure. Fast Passport Center provides the expedited, professional service that Brooklyn Park's diverse community needs — with document review, predictable timelines, and processing as fast as 24 hours.",
  ],
  nearbyCities: [
    { name: "Brooklyn Park", zips: "55428, 55429, 55443, 55444, 55445" },
    { name: "Maple Grove", zips: "55311, 55369" },
    { name: "Osseo", zips: "55311, 55369" },
    { name: "Plymouth", zips: "55441, 55442, 55446, 55447" },
    { name: "Champlin", zips: "55316" },
    { name: "Minneapolis", zips: "55401–55419" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required to begin. Complete your order from your home or office in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Brooklyn Park & Northwest Metro Coverage",
  serviceAreaDescription: "Serving Hennepin County communities with overnight courier pickup",
  faqs: [
    {
      q: "How fast can I get a passport in Brooklyn Park, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a post office in Brooklyn Park can take 2–6 months. For families with international travel plans, that timeline is simply not viable.",
    },
    {
      q: "Can North Hennepin Community College students get a passport fast?",
      a: "Yes. Study-abroad program deadlines often leave students with limited time. First-time applicants require an in-person acceptance clerk visit. We guide North Hennepin students through the exact location, forms, and timeline so they do not miss their program orientation.",
    },
    {
      q: "What if I need a passport for family travel abroad?",
      a: "Many Brooklyn Park families travel internationally to visit relatives. We process expedited renewals, new applications, and child passports for families on compressed timelines. Contact us as soon as travel dates are confirmed.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center?",
      a: "No — most Brooklyn Park travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Brooklyn Park. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Twin Cities metro area.",
    },
    {
      q: "What documents do I need for an expedited passport?",
      a: "Most applicants need: proof of U.S. citizenship, a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required.",
    },
    {
      q: "Is Fast Passport Center an official government agency?",
      a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing.",
    },
  ],
  testimonials: [
    {
      name: "Amina H.",
      location: "Brooklyn Park, MN",
      rating: 5,
      text: "We needed passports for our entire family to visit relatives in Nigeria. With three kids and only three weeks before our flight, we were panicking. Fast Passport Center handled everything — reviewed all our documents, guided us through the acceptance clerk visit, and got all five passports back in eight business days. Incredible service.",
      service: "Family Expedited Passports",
    },
    {
      name: "James L.",
      location: "Brooklyn Park, MN",
      rating: 5,
      text: "I got a new job that required international travel to Germany with two weeks notice. My passport had expired. Fast Passport Center processed my renewal in four business days. I made my flight and my first day of work overseas. Worth every penny.",
      service: "Passport Renewal",
    },
    {
      name: "Priya S.",
      location: "North Hennepin Area, Brooklyn Park",
      rating: 5,
      text: "I was accepted to a summer program in South Korea and needed my first passport in six weeks. The school orientation was non-negotiable. Fast Passport Center helped me find the right acceptance facility, reviewed my application, and got my passport in seven business days. I could not believe how smooth it was.",
      service: "New Passport",
    },
  ],
  nearbyLinks: [
    { name: "Minneapolis", href: "/cities/minneapolis" },
    { name: "St. Paul", href: "/cities/st-paul" },
    { name: "Plymouth", href: "/cities/plymouth-mn" },
    { name: "Maple Grove", href: "/cities/maple-grove" },
    { name: "Rochester", href: "/cities/rochester-mn" },
    { name: "Duluth", href: "/cities/duluth-mn" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Brooklyn Park",
  introDescription: "Fast, reliable passport processing for Brooklyn Park and northwest Hennepin County travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Brooklyn Park and Twin Cities resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Brooklyn Park Post Office",
      address: "5330 85th Ave N, Brooklyn Park, MN 55443",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(763) 566-1040",
      notes: "Passport acceptance services available by appointment. Photo services on-site. Primary facility for Brooklyn Park and northwest Hennepin County.",
    },
    {
      name: "Maple Grove Post Office",
      address: "9375 Deerwood Ln N, Maple Grove, MN 55369",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(763) 420-3122",
      notes: "Convenient for Maple Grove and northwest metro residents. Passport photos available. Call ahead for appointment availability.",
    },
    {
      name: "Osseo Post Office",
      address: "255 2nd Ave SE, Osseo, MN 55369",
      hours: "Mon–Fri 9:00 AM – 3:00 PM",
      phone: "(763) 425-2220",
      notes: "Serves Osseo and nearby Brooklyn Park residents. Smaller facility — appointments fill quickly.",
    },
    {
      name: "Minneapolis Main Post Office",
      address: "100 S 1st Ave, Minneapolis, MN 55401",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(612) 330-1444",
      notes: "Primary acceptance facility for downtown Minneapolis and northwest metro residents.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Brooklyn Park", address: "8400 Zane Ave N, Brooklyn Park, MN 55443", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Brooklyn Park", address: "8537 Zane Ave N, Brooklyn Park, MN 55443", hours: "Call for hours" },
    { name: "The UPS Store — Maple Grove", address: "13601 80th Cir N, Maple Grove, MN 55369", hours: "Call for hours" },
    { name: "Walgreens — Maple Grove", address: "15410 Maple Island Rd, Maple Grove, MN 55311", hours: "Call for hours" },
    { name: "CVS Pharmacy — Minneapolis", address: "2512 Hennepin Ave, Minneapolis, MN 55405", hours: "Daily 7 AM – 10 PM" },
    { name: "FedEx Office — Minneapolis", address: "801 Marquette Ave, Minneapolis, MN 55402", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Minnesota Driver and Vehicle Services — Hennepin County",
      address: "Hennepin County area offices",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, titles & registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Hennepin County Service Center — Minneapolis",
      address: "Minneapolis, MN 55401",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Downtown Minneapolis option. Online scheduling available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 20 miles from Brooklyn Park — 25 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary commercial airport for the Twin Cities. Nonstop service to major international hubs including Amsterdam, London, Paris, Tokyo, and Reykjavik.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "STC",
      name: "St. Cloud Regional Airport",
      distance: "St. Cloud, MN — about 55 miles northwest",
      address: "1550 45th Ave SE, St. Cloud, MN 56304",
      note: "Secondary option for northern Minnesota travelers. Regional connections to MSP.",
      flightUrl: "https://www.stcloudairport.com/",
      flightLabel: "St. Cloud Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "MSP — Minneapolis-Saint Paul International Airport",
      subtitle: "Primary gateway for Brooklyn Park international travelers",
      content:
        "MSP is the primary departure point for Brooklyn Park's international travelers. With nonstop service to Amsterdam, London, Paris, Tokyo, and Reykjavik, many residents connect directly to Europe and Asia. The airport's accessibility from the northwest metro makes it a convenient hub for both leisure and family travel.",
      tip: "Check your passport expiration before booking MSP international connections. Most countries require six months validity beyond your return date.",
      icon: "ri-flight-takeoff-line",
    },
    {
      title: "Family & Heritage Travel",
      subtitle: "International visits to relatives and cultural connections",
      content:
        "Brooklyn Park's diverse community includes many families who travel internationally to visit relatives in Africa, Asia, Latin America, and Europe. These trips are often planned around school breaks and holiday seasons, creating predictable but compressed booking windows. When a child's passport expires or a family member needs a first-time document, the standard processing timeline is too long.",
      tip: "Family passport renewals should be checked at the start of each calendar year. Children's passports are valid for only 5 years and expire faster than adult passports.",
      icon: "ri-parent-line",
    },
    {
      title: "College & Study Abroad",
      subtitle: "North Hennepin Community College and area programs",
      content:
        "North Hennepin Community College and nearby university programs send students abroad each year. Application deadlines for study-abroad programs often leave limited time for passport processing. First-time applicants require an in-person acceptance clerk visit, which adds another layer of planning.",
      tip: "Students should start their passport application as soon as they receive program acceptance — not after the orientation deadline is announced.",
      icon: "ri-graduation-cap-line",
    },
    {
      title: "Cruise & Vacation Travel",
      subtitle: "Caribbean cruises, European tours, and tropical getaways",
      content:
        "Brooklyn Park families book heavily into cruise packages and resort vacations. Last-minute deals and promotional packages create compressed booking-to-departure timelines. Many families discover passport issues only after booking, when cancellation fees are already in effect.",
      tip: "Even Caribbean cruises often require passports for all passengers. Check cruise line requirements before booking, and verify every family member's passport expiration date.",
      icon: "ri-ship-line",
    },
  ],
  destinations: [
    {
      name: "Nigeria & West Africa",
      context: "Family visits, cultural connections, and heritage travel for Brooklyn Park's West African community",
      urgency: "Family travel often planned around summer and holiday school breaks with 3–6 weeks notice",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "India & South Asia",
      context: "Family visits, weddings, and cultural events for the South Asian community",
      urgency: "Wedding and festival seasons create fixed travel dates that cannot be postponed",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico & Caribbean",
      context: "Family cruises, Cancun resort vacations, and spring break trips",
      urgency: "Last-minute cruise deals and resort packages happen 2–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "London business connections, heritage tourism, and MSP direct flights",
      urgency: "Business travel frequently has 7–21 day lead time",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Frankfurt business connections, trade shows, and European heritage trips",
      urgency: "Conference and trade show schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Canada",
      context: "Toronto visits, fishing trips to Ontario, and Winnipeg family connections",
      urgency: "Summer travel and holiday visits peak May through December",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    {
      stat: "58%",
      label: "of Brooklyn Park expedited requests are family or heritage travel discovered within 4 weeks of departure",
    },
    {
      stat: "2–5 Weeks",
      label: "average notice Brooklyn Park travelers have before a planned international trip",
    },
    {
      stat: "May–Dec",
      label: "peak season when summer vacations, school breaks, and holiday travel bookings collide",
    },
    {
      stat: "48 Hours",
      label: "shortest emergency turnaround we have accommodated for a Brooklyn Park family traveler",
    },
  ],
};

export default function BrooklynParkPage() {
  return <CityPage data={data} />;
}